import { render, staticRenderFns } from "./OnboardingStories.vue?vue&type=template&id=083e92bf&scoped=true"
import script from "./OnboardingStories.vue?vue&type=script&lang=js"
export * from "./OnboardingStories.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStories.vue?vue&type=style&index=0&id=083e92bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e92bf",
  null
  
)

export default component.exports